import { Box, BoxProps } from "@chakra-ui/react";
import { ZERO_DASH } from "utils/formatting";

export default function EmptyPlaceholder(props: BoxProps) {
  return <Box as="span" opacity={0.25} fontWeight={200} {...props} />;
}

export function NA({ children = "N/A", ...rest }: BoxProps) {
  return <EmptyPlaceholder {...rest}>{children}</EmptyPlaceholder>;
}

export function ZeroDash({ children = ZERO_DASH, ...rest }: BoxProps) {
  return (
    <EmptyPlaceholder fontWeight={600} {...rest}>
      {children}
    </EmptyPlaceholder>
  );
}
